import { render, staticRenderFns } from "./EventInformation.vue?vue&type=template&id=7716a31e&"
import script from "./EventInformation.vue?vue&type=script&lang=js&"
export * from "./EventInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!/Users/jurajpetras/dev/pmat/web/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BCol, BRow, BCardText, BCard} from 'bootstrap-vue'
    installComponents(component, {BCol, BRow, BCardText, BCard})
    

export default component.exports